import { AxiosResponse } from 'axios';
import ApiConstants from '../../../../core/constants/api_constants';
import { request } from '../../../../core/network/axiosInstance';
import { MarkResourceInterface } from '../../domain/interface/mark_resource_interface';

export class UserResourceApiService {
  private readonly userResourceBaseUrl: string;

  constructor() {
    this.userResourceBaseUrl = ApiConstants().userResource;
  }

  async markResourceAsViewed(data: MarkResourceInterface): Promise<AxiosResponse> {
    const response = await request({
      url: `${this.userResourceBaseUrl}view`,
      method: 'POST',
      data: data,
      headers: {
        'Content-Type': 'application/json',
      },
      requiresToken: true,
    });
    return response;
  }
}